import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { gridSizes, fontSizes, weights } from 'utils/style';
import { Field } from '@ontruck/orc';
import DefaultButton from 'refactored/ui/form/defaultButton';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import { actions } from 'state/auth';
import { isEmpty } from 'utils/types';
import { isEmailValid, urls, getConfig } from 'utils/auth';
import api from 'api';

class LandingRecoverFormComponent extends React.Component {
  constructor(props) {
    super(props);

    const { match } = this.props;
    this.state = {
      hasToken: (match && match.params && match.params.recoverToken) || false,
      isTokenValid: true,
      password: '',
      credential: '',
      error: false,
      fetching: false,
      success: false,
      errorField: false,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.recoverToken) {
      this.checkToken({ token: match.params.recoverToken });
    } else {
      this.setState({ isTokenValid: false });
    }
  }

  checkToken = async ({ token }) => {
    try {
      await api.post(urls.check, { token });
      this.setState({ isTokenValid: true });
    } catch (err) {
      this.setState({ isTokenValid: false });
    }
  };

  handleSubmitRequest = async (e) => {
    const { credential } = this.state;
    e.preventDefault();
    if (isEmpty(credential) || !isEmailValid(credential)) {
      this.setState({ errorField: true });
      return;
    }
    try {
      this.setState({ fetching: true });
      await api.post(urls.request, { credential });
      this.setState({ success: true });
    } catch (err) {
      this.setState({ error: true });
    } finally {
      this.setState({ fetching: false });
    }
  };

  handleSubmitReset = async (e) => {
    const { password } = this.state;
    e.preventDefault();
    if (isEmpty(password)) {
      this.setState({ errorField: true });
      return;
    }
    const { match, login } = this.props;
    const token = (match && match.params && match.params.recoverToken) || '';
    try {
      this.setState({ fetching: true });
      const {
        data: { username },
      } = await api.post(urls.reset, { password, token });
      login({ username, password });
    } catch (err) {
      this.setState({ error: true });
    } finally {
      this.setState({ fetching: false });
    }
  };

  setValue = (_, { name, value }) => {
    this.setState({ [name]: value, errorField: false });
  };

  getTitleClassNames = ({ hasToken, isTokenValid, error, success }) =>
    `title ${(hasToken && !isTokenValid) || error ? 'error' : ''} ${
      success ? 'success' : ''
    }`;

  render() {
    const { className, t } = this.props;
    const {
      error,
      credential,
      password,
      hasToken,
      isTokenValid,
      success,
      fetching,
      errorField,
    } = this.state;

    const {
      title = false,
      text = false,
      help = false,
      btn = false,
    } = getConfig({
      hasToken,
      isTokenValid,
      error,
      success,
      fetching,
    });
    return (
      <div className={className} data-testid="login-recover-form">
        {title && (
          <h2 className={this.getTitleClassNames(this.state)}>
            {t(`recover.${title}`)}
          </h2>
        )}

        <form
          className={`form ${errorField && 'form-error'}`}
          onSubmit={
            btn && isTokenValid
              ? this.handleSubmitReset
              : this.handleSubmitRequest
          }
        >
          {text && <p>{t(`recover.${text}`)}</p>}
          {help && <p>{t(`recover.${help}`)}</p>}

          {btn && !isTokenValid && (
            <Field
              id="credential"
              type="text"
              name="credential"
              onChange={this.setValue}
              label={t('recover.credential_label')}
              fullWidth
              value={credential}
              dataE2E="recover_credential"
              data-testid="recover_credential"
              disabled={fetching}
            />
          )}
          {isTokenValid && btn && (
            <div className="tax-data inspectlet-sensitive">
              <Field
                id="password"
                name="password"
                onChange={this.setValue}
                label={t('recover.password_label')}
                type="password"
                fullWidth
                value={password}
                dataE2E="recover_password"
              />
            </div>
          )}
          {btn && errorField && (
            <p className="error-field">
              {t(`recover.error_${!isTokenValid ? 'credential' : 'password'}`)}
            </p>
          )}

          {btn && (
            <DefaultButton
              id="submit"
              type="submit"
              size="L"
              text={t(`recover.${btn}`)}
              dataE2E="login_submit"
              data-testid="login_submit"
              disabled={fetching}
            />
          )}
        </form>
      </div>
    );
  }
}

LandingRecoverFormComponent.propTypes = {
  className: PropTypes.string.isRequired,
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
  t: PropTypes.func,
  login: PropTypes.func,
};

LandingRecoverFormComponent.defaultProps = {
  t: (t) => t,
  match: {},
  login: () => ({}),
};

const StyledLandingRecoverForm = styled(LandingRecoverFormComponent)`
  padding: 16px 0 16px 0; 
  width: 100%;
  max-width: 350px;
  background: var(--white);
  color: var(--grey800);
  font-size: ${gridSizes('M')};
  border-bottom: 1px solid var(--grey300);

  .title {
    font-weight: ${weights('medium')};
    font-size: ${gridSizes('L')};
    margin: 0;
    color: var(--grey800);
  }
  .form {
    margin: 12px 0 0;
    color: var(--grey800);
    div input {
      border: 1px solid var(--grey200);
      border-radius: 4px;
      margin:4px 0;
    }
  }
  .form-error {
    div input {
      border: 1px solid var(--red-cherry-text);
    }
  }
  .error-msg {
    font-size: 14px;
    color: var(--red-cherry-text);
    margin: ${gridSizes('S')} 0 0;
  }

  .error-field {
    color: var(--red-cherry-text);
    padding-top: ${gridSizes('XS')};
    padding-bottom: ${gridSizes('XS')};
    font-size: ${fontSizes('S')};
    margin: 0;
  }

  .error-msg {
    font-size: 14px;
    color: var(--red-cherry-text);
    margin: ${gridSizes('S')} 0 0;
  }

  button {
    margin: ${gridSizes('S')} 0 0;
    width: 100%;
    height: 32px !important;
    font-size: 14px !important;
  }
  a {
    display: block;
    font-size: 14px;
    font-weight: ${weights('medium')};
    color: var(--grey700);
    text-decoration: none;
    margin: ${gridSizes('M')} 0 0;
    text-align: center;
    &:hover {
      text-decoration: underline;
    }
  }
`;

const enhance = compose(
  withTranslation('Login'),
  connect(() => ({}), {
    login: actions.login,
  })
);

const LandingRecoverForm = enhance(StyledLandingRecoverForm);
export { LandingRecoverForm };